import dayjs from 'dayjs';
import { concat, map, noop } from 'lodash';
import * as React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Database } from '../../Managers/DataManager';
import { VideoTile } from '../VideoShelf/VideoTile';
import styled from 'styled-components';
import { truncate} from 'lodash'
import VisibilitySensor from 'react-visibility-sensor';
import { ImageAnimations } from '../Image/Image';


const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap; 
    min-height: 70vh;
    min-width: 80vw;
    padding-bottom: 100px;
    flex: 1;
`

const MobileGroup = styled.div`
    @media (max-width: 534px){
        display: flex;
    }
`
const Margin = styled.div`
    margin-top: 1em;
    margin-bottom: 1em;
    margin-right: 0.5em; 
    width: calc((100vw - (160px + 4vw)) / 5);

    @media (max-width: 1799px){
        width: calc((100vw - (160px + 3vw)) / 4);
    }

    @media (max-width: 1279px){
        width: calc((100vw - (0.5em + 160px + 2vw)) / 3);
    }

    @media (max-width: 989px){
        width: 220px;
        flex: 1;
    }

    @media (max-width: 534px){
        width: 90vw;
    }

`

const Title = styled.h3`
    font-size: 1em;
    font-weight: bold;
    color: white;

    @media (max-width: 534px){
       display: none;
    }
`
const SideTitle = styled.h3`
    font-size: 0.8em;
    font-weight: bold;
    color: white;
    margin-left: 1em;

    @media (min-width: 535px){
        display: none;
     }
`
const Desc = styled.p`
    color: rgba(200, 200, 200, 1);
    @media (max-width: 534px){
        font-size: 0.8em;
    }
`

const Button = styled.button`
    border: 1px solid #cccccc;
    padding: 0.7em 3em;
    border-radius: 4px; 
    color: white;
    font-size: 1em;
    background-color: transparent;

`

const Center = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1
`

export const AllEpisodes = props => {
    const autoLoadLimit = 2
    const { program }  = props
    const [offset, setOffset] = useState(dayjs().valueOf()) // a time stamp
    const [videos, setVideos] = useState([])
    const [autoLoads, setAutoLoads] = useState(0)
    const [loads, setLoads] = useState(0)


    const onAutoLoad = (visible) => {
        if(!program?.id){ return }
        if(visible){
            setAutoLoads(autoLoads + 1)
        }

    }
    const leaving = new Subject<void>()
    useEffect(() => {
        if(!program?.id) { return }
        if(program?.num_videos <= videos?.length){ return }
        Database.get(`episodes?id=${program.id}&offset=${offset}&size=15`)
        .then(obs => {
            obs.pipe(takeUntil(leaving))
            .subscribe(vids => {
                if(!vids){ return }
                const vs = concat(videos, vids) 
                setVideos(vs)
            })
        })

        return () => leaving.next()
    }, [program, autoLoads, loads])

    const loadMore = () => {
        setLoads(loads + 1)
    }

    useEffect(() => {
        if(!videos || videos?.length === 0){ return }
        const last = videos?.[videos?.length - 1]
        if(last?.date){
            setOffset(last.date)
        }
        
    },[videos])

    const renderTile = (video) => {
        return(
            <Margin>
                <MobileGroup>
                    <VideoTile item={video} animation={ImageAnimations.scale}/>
                    <SideTitle>{video?.name}</SideTitle>
                </MobileGroup>
                <Title>{video?.name}</Title>
                <Desc>{truncate(video?.long_text, {'length': 150})}</Desc>
            </Margin>
        )
    }


    return(
        <Container>
            {map(videos, video => <Margin key={video?.name}>{renderTile(video)}</Margin>)}
            {autoLoads <= autoLoadLimit && program?.num_videos > videos?.length && <LoadMore onVisible={onAutoLoad} />}
            {autoLoads > autoLoadLimit && program?.num_videos > videos?.length && <Center>
                <Button onClick={loadMore}>Load More</Button>
            </Center>}
       </Container>
    )
}

const LoadMore = (props) => {

    const {onVisible} = props
 


    return (
        <VisibilitySensor onChange={onVisible}>
           <div style={{width: 'calc(90vw - 60px)', height: 200}}></div>
        </VisibilitySensor>
    )
}

